import Head from 'next/head'
import { Text, Title } from '@mantine/core'
import { NextSeo } from 'next-seo'

import * as Types from '../declarations'
import { withVersion } from 'lib/withVersion'
import { getDefaultImage } from 'lib/helper'

import PageTemplate from '../components/PageTemplate'

const Terms = ({ version }: { version: Types.VERSION }) => {
	const websiteName = `Guided ${
		version === Types.VERSION.TREKKING ? 'Trekking' : 'Peaks'
	}`

	const seo = {
		title: `Links & Resources - ${websiteName}`,
		description: `Explore a curated list of mountaineering-related links and resources, connecting you to relevant websites for climbers and adventurers`,
		siteName: websiteName,
		canonical: `https://www.guided${
			version === Types.VERSION.TREKKING ? 'trekking' : 'peaks'
		}.com/links-resources`,
		images: [
			{
				url: getDefaultImage(version),
				type: 'image/jpeg',
			},
		],
	}

	const partnerLinks = [
		{
			title: 'Better Guiding',
			link: 'https://www.betterguiding.com',
			description:
				'Recommended Platform for guides to run their agency: Streamline Your Guide Agency Operations.',
		},
		{
			title: 'Sunrise Bookings',
			link: 'https://www.sunrisebookings.com',
			description:
				'Works with Stripe - Manage your bookings, payments, and more with Sunrise Bookings.',
		},
		...(version === Types.VERSION.TREKKING
			? [
					{
						title: 'Guided Peaks',
						link: 'https://www.guidedpeaks.com',
						description:
							'Discover guided mountain expeditions worldwide with high-quality resources and expert insights for climbers and adventurers.',
					},
			  ]
			: []),

		...(version === Types.VERSION.PEAKS
			? [
					{
						title: 'Guided Trekking',
						link: 'https://www.guidedtrekking.com',
						description:
							'Discover guided treks worldwide with high-quality resources and expert insights for trekkers and adventurers.',
					},
					// {
					// 	title: `Younes's Blog`,
					// 	link: 'https://youdo.blog',
					// 	description: 'An Algerian content entrepreneur.',
					// },
					// {
					// 	title: `Tidelas`,
					// 	link: 'https://www.tidelas.com',
					// 	description:
					// 		'The best location guide and community for eFoil, kiteboard and wingfoil enthusiasts.',
					// },
					// {
					// 	title: `AI Trip Planner`,
					// 	link: 'https://letstrip.ai',
					// 	description: 'Your dream trip, perfectly planned by AI.',
					// },
					// {
					// 	title: `Alpine Ramble Treks`,
					// 	link: 'https://www.alpineramble.com/',
					// 	description:
					// 		'We are a leading Kathmandu-based trekking agency recognized by our valued customers for arranging first-class tours of the Himalayas with passion and enthusiasm.',
					// },
					// {
					// 	title: `alleviate the symptoms of burnout`,
					// 	link:
					// 		'https://www.breakfastleadership.com/blog/revitalize-your-mind-using-nature-as-a-remedy-for-burnout',
					// 	description: `Being in nature can have a calming and restorative effect, helping to alleviate the symptoms of burnout by reducing stress and promoting a sense of relaxation and well-being. Spending time outdoors, whether it's taking a leisurely walk in a park, hiking in the woods, or simply sitting and observing the natural world, can provide a much-needed respite from the demands of daily life and recharge one's mental and physical energy.`,
					// },
			  ]
			: []),
	]

	return (
		<>
			<Head>
				<title>{seo.title}</title>
			</Head>
			<NextSeo
				title={seo.title}
				description={seo.description}
				canonical={seo.canonical}
				openGraph={{
					url: seo.canonical,
					title: seo.title,
					description: seo.description,
					images: seo.images,
					siteName: seo.siteName,
					type: 'website',
					locale: 'en_US',
				}}
			/>
			<PageTemplate>
				<Title order={1}>Links & Resources</Title>

				<Title order={2} mt="xl" mb="lg">
					About this Page
				</Title>

				<Text>
					Explore our trusted partners, resources, and recommended sites that
					enrich the {version === Types.VERSION.PEAKS ? 'climbing' : 'trekking'}{' '}
					and adventure community. These links are curated to provide our users
					with useful, high-quality information from credible sources in the
					outdoor and{' '}
					{version === Types.VERSION.PEAKS ? 'mountaineering' : 'trekking'}{' '}
					industry.
				</Text>

				<Title order={2} mt="xl" mb="lg">
					Partner Links
				</Title>

				<ul style={{ listStyleType: 'none', padding: 0 }}>
					{partnerLinks.map((partner, index) => (
						<li key={index} style={{ marginBottom: '1.5rem' }}>
							<a href={partner.link} target="_blank" rel="noopener noreferrer">
								{partner.title}
							</a>
							<p style={{ margin: '0.5rem 0', color: '#555' }}>
								{partner.description}
							</p>
						</li>
					))}
				</ul>
			</PageTemplate>
		</>
	)
}

export const getStaticProps = withVersion(
	async (context: { version?: Types.VERSION }) => {
		return { props: { version: context?.version } }
	},
)

export default Terms
